import axios from 'axios';
import React, { useEffect, useState } from 'react';
import FullSizeLoaderError from '../components/FullSizeError';
import FullSizeLoader from '../components/FullSizeLoader';
import globalConfig, { DynamicConfig } from '../config/config';
import { prefixPath } from '../utils/helpers';

const ConfigWrapper = ({ children }: React.PropsWithChildren): JSX.Element => {
    const [configResponse, setConfigResponse] = useState<'LOADING' | 'FAILED' | 'LOADED'>('LOADING');

    /**
     * to fetch a config file and load it in memory
     */
    const loadConfig = async () => {
        try {
            const response: { data: DynamicConfig } = await axios.get(prefixPath(`/${globalConfig.getUrl}`));
            globalConfig.setConfig = response.data;
            /** set error if the doesn't found any of the below base urls */
            if (
                globalConfig.getConfig &&
                (!globalConfig.getConfig.urls.protocol.backend || !globalConfig.getConfig.urls.other.backend.auth)
            ) {
                return setConfigResponse('FAILED');
            }
            setConfigResponse('LOADED');
        } catch (error) {
            setConfigResponse('FAILED');
        }
    };

    useEffect(() => {
        loadConfig();
    }, []);

    return (
        <>
            {configResponse === 'LOADING' && <FullSizeLoader />}
            {configResponse === 'FAILED' && <FullSizeLoaderError />}
            {configResponse === 'LOADED' && children}
        </>
    );
};

export default ConfigWrapper;
